export default [{
  id: 'hours',
  label: 'Hourly',
  description: 'Time is billed hourly by default. Fixed fees and non-billable hours can still be added.'
}, {
  id: 'contingency',
  label: 'Contingency',
  description: 'Time is marked as non-billable by default. Hourly billed time and fixed fees can still be added.'
}, {
  id: 'fixed',
  label: 'Fixed Fee',
  description: 'Time is marked as included in the fixed fee by default. Hourly billed time can still be added.'
}, {
  id: 'none',
  label: 'Pro Bono',
  description: 'Time is marked as non-billable by default. Hourly billed time and fixed fees can still be added.'
}, {
  id: 'internal',
  label: 'Internal',
  description: 'Time can only be non-billable and will be hidden from most billing filters.'
}];